import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_APP_URL}api`,
  // Needed so browser sends/receives cookies
  withCredentials: true
});

export default instance;
